import { Swiper, Autoplay, Pagination } from 'swiper';

export default () => {
  Swiper.use([Autoplay, Pagination]);

  new Swiper('.js-slideshow', {
    direction: 'horizontal',
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 7000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    preloadImages: true,
    watchOverflow: true,
    spaceBetween: 0,
    updateOnImagesReady: true,
    freeMode: true,
    freeModeMomentumBounceRatio: 0.1,
    freeModeSticky: true,
  });
};
